// extracted by mini-css-extract-plugin
module.exports = {"content":"work-module--content--5S9GA"};